<template>
  <div class="seller-center-title">
    <h2 class="title-text">
      {{ titleText }}
    </h2>
    <div class="options-slot">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SellerCenterTitle',
  props: {
    titleText: {
      type: String,
      default: 'Seller Center Title'
    }
  }
}
</script>

<style scoped>
.seller-center-title{
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dcdee2;
  padding-bottom: 5px;
  margin-bottom: 15px;
}
.title-text{
  flex: 1;
}
h2{
  border: none;
  margin-bottom: 0;
}
</style>
